import { createContext, useContext, useState } from 'react';
import { translations } from '../data/translations';

const LangContext = createContext();

export function LangProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem('gemiya-lang') || 'fr');

  const setLang = (newLang) => {
    setLangState(newLang);
    localStorage.setItem('gemiya-lang', newLang);
  };

  const t = (key) => translations[lang][key] || key;
  return (
    <LangContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LangContext.Provider>
  );
}

export function useLang() {
  return useContext(LangContext);
}
